







































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class CreateOrEditForm extends Vue {
  @Prop() assetId!: string;

  @Prop() addressId!: string;

  @Prop() asset;

  loading = false;

  initing = false;

  hasMemo = true;

  destination = "";

  label = "";

  tag = "";

  get logo() {
    return this.asset.icon_url;
  }

  get chainLogo() {
    return this.$common.utils.helper.getChainLogo(this, this.asset);
  }

  get rules() {
    return {
      label: [
        v => !!v || this.$t("wallet.address.create.errors.label-require")
      ],
      destination: [
        v => !!v || this.$t("wallet.address.create.errors.destination-require")
      ],
      tag: [v => !!v || this.$t("wallet.address.create.errors.tag-require")]
    };
  }

  get assetSymbol() {
    return (this.asset && this.asset.symbol) || "";
  }

  mounted() {
    this.init();
  }

  async init() {
    this.initing = true;
    if (this.addressId) {
      await this.requestAddressInfo(this.addressId);
    }
    this.initing = false;
  }

  handleSaveAddress() {
    const form: any = this.$refs.form;
    const valid = form.validate();
    if (valid) {
      this.requestSaveAddress();
    }
  }

  requestSaveAddress() {
    let url = `mixin://address?destination=${
      this.destination
    }&label=${encodeURIComponent(this.label)}&asset=${this.assetId}`;
    if (this.hasMemo) {
      url += `&tag=${this.tag}`;
    }
    window.location.href = url;
    this.$root.$emit(
      this.$rootEvents.PIN_ENTER,
      this.handleConfirm.bind(this),
      this.handleCancel.bind(this)
    );
  }

  handleCancel() {
    this.loading = false;
  }

  handleConfirm() {
    this.toAddresses();
  }

  toggleMemo() {
    this.hasMemo = !this.hasMemo;
    this.tag = "";
  }

  async requestAddressInfo(id) {
    try {
      const res = await this.$api.wallet.mixin.getAddress(id);
      this.destination = res.destination;
      this.label = res.label;
      this.tag = res.tag;
      this.hasMemo = Boolean(res.tag);
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }

  toAddresses() {
    this.$helper.toFusionPath(this, "wallet", {
      name: "addresses-id",
      params: { id: this.assetId }
    });
  }
}
export default CreateOrEditForm;
